export enum MimeTypes {
	VIDEO_MP4 = "video/mp4",
	VIDEO_MPEG = "video/mpeg",
	VIDEO_WEBM = "video/webm",
	VIDEO_X_FLV = "video/x-flv",
	VIDEO_X_M4V = "video/x-m4v",
	IMAGE_JPEG = "image/jpeg",
	IMAGE_PNG = "image/png",
	IMAGE_APNG = "image/apng",
	IMAGE_TIFF = "image/tiff",
	IMAGE_GIF = "image/gif",
	IMAGE_WEBP = "image/webp",
	IMAGE_BMP = "image/bmp",
	IMAGE_SVG = "image/svg+xml",
	IMAGE_X_ICON = "image/x-icon",
	IMAGE_ICO = "image/ico",
	IMAGE_CUR = "image/cur",
	IMAGE_HEIC = "image/heic",
	IMAGE_HEIF = "image/heif",
	AUDIO_WAV = "audio/wav",
	AUDIO_OGG = "audio/ogg",
	AUDIO_OPUS = "audio/opus",
	AUDIO_MP4 = "audio/mp4",
	AUDIO_MPEG = "audio/mpeg",
	AUDIO_AAC = "audio/aac",
	TEXT_PLAIN = "text/plain",
	TEXT_HTML = "text/html",
	TEXT_CSS = "text/css",
	TEXT_CSV = "text/csv",
	TEXT_X_SQL = "text/x-sql",
	APPLICATION_XML = "application/xml",
	APPLICATION_SQL = "application/sql",
	APPLICATION_X_SQL = "application/x-sql",
	APPLICATION_X_SQLITE3 = "application/x-sqlite3",
	APPLICATION_X_PKCS12 = "application/x-pkcs12",
	APPLICATION_PDF = "application/pdf",
	APPLICATION_JSON = "application/json",
	APPLICATION_JAVASCRIPT = "application/javascript",
}
